import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "thread-footer",
  templateUrl: "thread-footer.component.html",
  styleUrls: ["thread-footer.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadFooterComponent implements OnInit {
  @Input() public commentId: string;
  @Input() public repliesCount: number;
  @Input() public lastReplyAt: string;
  @Input() public usersReplied: Set<string>;

  public usersRepliedIds: string[];

  public ngOnInit(): void {
    this.usersRepliedIds = [...this.usersReplied];
  }
}
